import { useCallback } from 'react'
import useNetworkId from '../../../hooks/useNetworkId'
import { ThemedButton } from '../../ThemedButton'
import { Strong } from '../Typeography'
import { BLAST } from '../../../constants'

function SwitchToBlastButton({
  $styleType = 'surface-chip',
  w,
}: {
  $styleType?: string
  w?: string
}) {
  const { changeNetwork } = useNetworkId()

  const switchToDesiredNetwork = useCallback(() => {
    changeNetwork(BLAST.chainId)
  }, [changeNetwork])

  return (
    <ThemedButton
      onClick={switchToDesiredNetwork}
      $styleType={$styleType}
      type="button"
      w={w}
    >
      <img
        src="/img/icons/chains/color-circle/blast.svg"
        alt="switch to blast"
        height={20}
        width={20}
      />
      <Strong>Switch to BLAST</Strong>
    </ThemedButton>
  )
}

export default SwitchToBlastButton
